import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectStarredPinKeys, toggleStarredPin } from 'ducks/client/starredPins';

export const useStarredPins = () => {
  const dispatch = useDispatch();
  const starredPinKeys = useSelector(selectStarredPinKeys);

  const toggleStar = useCallback(
    (pinKey: string) => {
      dispatch(toggleStarredPin(pinKey));
    },
    [dispatch]
  );

  const isStarred = useCallback((pinKey: string) => starredPinKeys.includes(pinKey), [
    starredPinKeys,
  ]);

  return {
    toggleStar,
    isStarred,
    starredPinKeys,
  };
};
